import React from 'react';
import { Input } from 'reactstrap';
import { T } from '../traks';
import { current_site_id } from '../Site';

const PostcodeSelector = (props) => {
    let pattern = "[0-9]*"
    let maxLength = 4

    if (current_site_id === 'AKTIEKAMPEN_SE') {
        pattern = "[0-9]{3}\s?[0-9]{2}"
        maxLength = 6
    } else if (current_site_id === 'INVESTSPIEL_DE') {
        maxLength = 10
    }

    return (
        <div>
            <span className="ad_little_larger_txt"><b><T>Postcode:</T></b></span>
            <Input
            type="text"
            className="form-control"
            name="postal_code"
            pattern={pattern}
            inputMode="numeric"
            autoComplete="off"
            maxLength={maxLength}
            value={props.postcode}
            onChange={props.onChange}
            style={{width: "20em"}} />
        </div>
    )
}

export default PostcodeSelector;


// WEBPACK FOOTER //
// ./src/c/PostcodeInput.js